module.exports = __webpack_public_path__ + "img/cab4412.png";